/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/input/text';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';
import { createAlert } from '@src/actions/_utils';
import BotBuilderContants from '@src/phrases';
import { AlertTypes } from 'constants/MogamboConstants';
import styles from './RegexEntityConfig.scss';
import { isValidRegex } from './utils';

const KEYWORDS = BotBuilderContants.getPhrase;

export default class RegexEntityConfig extends React.Component {
  state = {
    testString: '',
  };

  render() {
    let regexTestResult = null;
    try {
      const patt = new RegExp(`(${this.props.metaData.regex})`, 'g');
      regexTestResult = this.state.testString.replace(
        patt,
        '<span style="background-color:yellow">$1</span>'
      );
    } catch (err) {
      regexTestResult = '<span>Your regex does not work</span>';
    }
    return (
      <div className={styles.container}>
        <div className={styles.left}>
          <Text
            disabled={this.props.disabled}
            label="Enter the Regex"
            placeholder="Regex pattern this entity should detect"
            value={this.props.metaData.regex}
            onChange={this._regexPatternChanged}
          />
          <Text
            label="Test the Regex"
            placeholder="Write any text to check if the regex is able to detect it"
            value={this.state.testString}
            onChange={this._testStringChanged}
          />
          <div className="col col-sm-12" style={{ marginTop: '10px' }}>
            <span
              dangerouslySetInnerHTML={{
                __html: regexTestResult,
              }}
            />
          </div>
        </div>
        <div className={styles.right}>
          <div>
            <div className={styles.header}>How to use Regex?</div>
            <div className={styles.row}>
              <div className={styles.key}>For example:</div>
              <div>
                If your regex is:{' '}
                <span className={styles.sampleRegex}>
                  0 \d
                  {'{10}'}
                </span>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.key}>
                {KEYWORDS('USER_MESSAGE.PLURAL.CAPITALIZE')}:
              </div>
              <div>
                My number is &nbsp;
                <span className={styles.matchingText}> 0 5868273829</span>
              </div>
            </div>
            <div className={styles.row}>
              Whenever a `{KEYWORDS('USER_MESSAGE.PLURAL.CAPITALIZE')}` has `0`
              and a space before 10 digits number, then just that part of his
              response will be collected and used for the entity value
            </div>
            <div className={styles.row}>
              One can checkout this list of commonly used regex to save time:
            </div>
            <a
              href="http://www.rexegg.com/regex-quickstart.html"
              target="_blank"
              rel="noreferrer"
            >
              List of commonly used regex
            </a>
          </div>
        </div>
      </div>
    );
  }

  _regexPatternChanged = (value) => {
    this.props.onChange({ regex: value });
  };

  _testStringChanged = (value) => {
    this.setState({
      testString: value,
    });
  };

  validate = () => {
    if (!this.props.metaData.regex || this.props.metaData.regex.length === 0) {
      createAlert('Please specify the regex', undefined, AlertTypes.NEGATIVE);
      return false;
    }
    if (!isValidRegex(this.props.metaData.regex)) {
      createAlert('Invalid regular expression', undefined, AlertTypes.NEGATIVE);
      return false;
    }
    return true;
  };
}

RegexEntityConfig.propTypes = {
  metaData: PropTypes.shape({
    regex: PropTypes.string,
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
